import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetBaseStatusRequest,
  GetBaseStatusResponse,
  CreateBaseStatusRequest,
  CreateBaseStatusResponse,
  DeleteBaseStatusRequest,
  DeleteBaseStatusResponse,
  UpdateStatusPositionIdxRequest,
  UpdateStatusPositionIdxResponse,
} from "../../models/BaseStatus.model";

const API_BASE_URL = environment.apiUrl;

export const getBaseStatus = createAsyncThunk<
  GetBaseStatusResponse,
  GetBaseStatusRequest,
  { rejectValue: string }
>("baseStatus/getBaseStatus", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Status/GetBaseStatus`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: GetBaseStatusResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to fetch base statuses");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const createBaseStatus = createAsyncThunk<
  CreateBaseStatusResponse,
  CreateBaseStatusRequest,
  { rejectValue: string }
>("baseStatus/createBaseStatus", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Status/CreateBaseStatus`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: CreateBaseStatusResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to create base status");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const deleteBaseStatus = createAsyncThunk<
  DeleteBaseStatusResponse,
  DeleteBaseStatusRequest,
  { rejectValue: string }
>("baseStatus/deleteBaseStatus", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Status/DeleteBaseStatus`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data: DeleteBaseStatusResponse = await response.json();

    if (!data.success) {
      return rejectWithValue(data.message || "Failed to delete base status");
    }

    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const updateStatusPositionIdx = createAsyncThunk<
  UpdateStatusPositionIdxResponse,
  UpdateStatusPositionIdxRequest,
  { rejectValue: string }
>(
  "baseStatus/updateStatusPositionIdx",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Status/UpdateStatusPositionIdx`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data: UpdateStatusPositionIdxResponse = await response.json();

      if (!data.success) {
        return rejectWithValue(
          data.message || "Failed to update status position"
        );
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
